import React, { memo, ReactElement, ReactNode, useContext, useMemo } from "react";

// context
import { PaymentPayContext } from "@payment-client/contexts/PaymentPayContext";
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";

// components
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";

// helpers
import { getPaymentHeaderSubtitleForSubRoutesV4 } from "@payment-client/helpers/PaymentHelper";
import { getItemCountAndAnnotation } from "@payment-client/helpers/CheckoutMetaHelper";

//misc
import { CheckoutRoute, useCustomHardwareBack } from "@swiggy-private/checkout-core";

//styles
import styles from "./styles.scss";

function PaymentTxnStatusPollerWrapper(props: { children: ReactNode; onBack: VoidFunction }): ReactElement {
    const { checkoutMetaInfo, paymentResponse } = useContext(ShowPaymentContext);
    const { cartItemsCount, addressAnnotation } = useMemo(() => getItemCountAndAnnotation(checkoutMetaInfo), [
        checkoutMetaInfo,
    ]);
    const { amountToPay } = useContext(PaymentPayContext);

    const subtitleText = useMemo(() => {
        return getPaymentHeaderSubtitleForSubRoutesV4({
            selectedAddressAnnotation: addressAnnotation,
            cartAmount: String(amountToPay),
            itemCount: cartItemsCount,
            presentationDetails: paymentResponse?.presentationDetails,
        });
    }, [addressAnnotation, amountToPay, cartItemsCount, paymentResponse]);

    // Show Cancel Popup on hardware back
    useCustomHardwareBack([CheckoutRoute.PAYMENT_TXN_STATUS_POLLING], props.onBack);

    const header = <CommonHeaderContent title={"PAYMENT DETAILS"} subtitle={subtitleText} grayscale />;

    return (
        <CommonUIWrapper
            onBack={props.onBack}
            header={header}
            content={props.children}
            containerCSSClass={styles.container}
        />
    );
}

export default memo(PaymentTxnStatusPollerWrapper);
